import { Button, Card } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { SectionContainer } from '@components/shared';
import {
    HeaderBreadcrumb,
    SectionDataTable,
    SectionTitle,
} from '@components/ui';

import { Route } from '@/constants';
import { stockAdjustmentListColumns } from '@/modules/adjustment/stock-adjustment/stock-adjustment-list/stock-adjustment-list.column';
import { useStockAdjustmentList } from '@/modules/adjustment/stock-adjustment/stock-adjustment-list/stock-adjustment-list.hook';

export const StockAdjustmentList = () => {
    const { data, isLoading, isError, isFetching, error } =
        useStockAdjustmentList();
    return (
        <SectionContainer
            fallbackPath={Route.DASHBOARD}
            isError={isError}
            isLoading={isLoading}
            error={error}
        >
            <Card className={'space-y-4 p-4'}>
                <div className={'flex justify-between '}>
                    <div className={'space-y-4'}>
                        <HeaderBreadcrumb
                            items={[
                                {
                                    label: 'Stocks',
                                    href: Route.STOCK_ALL_PRODUCTS,
                                },
                                { label: 'Stock Adjustments' },
                            ]}
                            showHomeLink={true}
                        />
                        <SectionTitle>Recent Stock Adjustments</SectionTitle>
                    </div>

                    <Link to={Route.ADJUSTMENT_STOCK_CREATE}>
                        <Button type={'button'} className={''}>
                            Add Adjustment
                        </Button>
                    </Link>
                </div>

                <SectionDataTable
                    columns={stockAdjustmentListColumns}
                    data={data}
                    isLoading={isLoading || isFetching}
                />
            </Card>
        </SectionContainer>
    );
};

StockAdjustmentList.displayName = 'StockAdjustmentList';
